import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize, Subject } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';
import { ApiError } from '../../../core/transport/api-error';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);


  showPassword: boolean;

  loginForm: FormGroup;

  errorMessage: string | null = null;

  loading$: Subject<boolean | null> = new Subject();

  constructor() {
    const formBuilder = this.formBuilder;

    this.showPassword = false;
    this.loginForm = formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    });
  }

  showError(controlName: string, errorCode: string): boolean {
    const control = this.loginForm.get(controlName);

    return !!control && control.touched && control.hasError(errorCode);
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.errorMessage = null;
    this.loading$.next(true);

    this.authService.login(this.loginForm.value).pipe(
      finalize(() => {
        this.loading$.next(false);
      })
    ).subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: (error: ApiError) => {
        this.errorMessage = error?.status >= 500
          ? 'Sign in failed. Please try again.'
          : (error?.message || 'Sign in failed. Please try again.');
        this.changeDetectorRef.markForCheck();
      },
    });
  }

}
